import React, { useEffect, useState } from 'react';
import useQuery from '../../hooks/use-query';
import Loader from 'monday-ui-react-core/dist/Loader';
import { orderLinksAPI } from '../../api';
import { S3_BUCKET_PREFIX } from '../../constants';

import './preview-view.scss';

export default function PreviewView() {
  const query = useQuery();
  const id = query.get('id');
  const [orderHtml, setOrderHtml] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isSubscribed = true;
    const getOrderLink = async () => {
      try {
        const { fileKey } = await orderLinksAPI.fetchOrderLink({ orderLinkId: id });
        const response = await fetch(`${S3_BUCKET_PREFIX}/${fileKey}`);
        const body = await response.text();
        if (!isSubscribed) return;
        setOrderHtml(body);
        setLoading(false);
      } catch (e) {}
    };

    getOrderLink();

    return () => (isSubscribed = false);
  }, [id, setOrderHtml, setLoading]);

  return (
    <div className="preview-view">
      <div className="order-wrapper">
        {loading ? (
          <div className="loader-wrapper">
            <Loader />
          </div>
        ) : (
          <div className="order-html-injected" dangerouslySetInnerHTML={{ __html: orderHtml }}></div>
        )}
      </div>
    </div>
  );
}
